import React from 'react';
import CountUp from '../CountUp';
import Reveal from './Reveal';
import { ArrowUpRightIcon } from './icons';
import './styles.scss';

const chain = [
  { num: '01', label: 'Crews capture' },
  { num: '02', label: 'The record builds' },
  { num: '03', label: 'Admin drops' },
  { num: '04', label: 'Answers surface' },
  { num: '05', label: 'Closeout proves it' },
];

const results = [
  {
    stat: <CountUp value={67} suffix="%" duration={900} />,
    title: 'Faster issue resolution',
    body: 'RFIs, punch, and daily reporting that used to crawl through email and paper now close in a stamped thread.',
  },
  {
    stat: <CountUp value={60} prefix="$" suffix="K+" duration={900} />,
    title: 'Kept per year',
    body: 'The floor of what builders save versus percentage-of-volume platform quotes. The ceiling runs to $700K+.',
  },
  {
    stat: <CountUp value={61} suffix=" days" duration={900} />,
    title: 'To ROI',
    body: 'Most teams see the platform pay for itself well before the free trial ends — which is exactly why the trial runs 90 days.',
  },
];

export default function OutcomesSection() {
  return (
    <section className="plh-outcomes">
      <div className="plh-outcomes__head">
        <Reveal>
          <p className="plh-eyebrow">What changes</p>
          <h2>
            When the crew uses it,{' '}
            <span className="plh-accent">the whole business feels it.</span>
          </h2>
        </Reveal>
        <Reveal className="plh-outcomes__explainer" delay={120}>
          <p>
            Adoption isn&rsquo;t a metric — it&rsquo;s the mechanism. Free sub accounts and
            two-minute onboarding get the crews in; everything after that compounds.
          </p>
        </Reveal>
      </div>

      <Reveal className="plh-chain" delay={80}>
        <div className="plh-chain__track">
          {chain.map((stepItem, idx) => (
            <React.Fragment key={stepItem.num}>
              {idx > 0 && (
                <span className="plh-chain__arrow" aria-hidden="true">
                  →
                </span>
              )}
              <span className="plh-chain__step" style={{ transitionDelay: `${idx * 120}ms` }}>
                <span className="plh-chain__num plh-mono">{stepItem.num}</span>
                {stepItem.label}
              </span>
            </React.Fragment>
          ))}
        </div>
      </Reveal>

      <div className="plh-outcomes__grid">
        {results.map((result, idx) => (
          <Reveal className="plh-result" key={result.title} delay={idx * 90}>
            <span className="plh-result__glyph" aria-hidden="true">
              <ArrowUpRightIcon />
            </span>
            <span className="plh-result__stat">{result.stat}</span>
            <p className="plh-result__title">{result.title}</p>
            <p className="plh-result__body">{result.body}</p>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
